import { Stack, Typography, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useFormValues } from '@client/hooks/formik.hooks';
import { ProfileTypes } from '@sda/enums';
import { CheckboxGroup } from '@client/components/forms/CheckboxGroup';
import { Checkbox } from '@client/components/forms/Checkbox';
import { MenuItem } from '@client/components/forms/Select/MenuItem';
import { MultipleSelect } from '@client/components/forms/Select/MultipleSelect';
import { FilterOptions, RequiresPAOptions } from '../../../interfaces';
import { Genres } from './Genres';
import { VenueTypes } from './VenueTypes';

const useStyles = makeStyles()((theme) => ({
  filterGridItem: {
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}));

interface FiltersProps {
  readonly gridSpacing: number;
  readonly isMobile: boolean;
}

export const Filters: React.FC<FiltersProps> = ({ gridSpacing, isMobile }) => {
  const { classes } = useStyles();
  const searchType = useFormValues<ProfileTypes>('searchType');

  return (
    <Stack spacing={2}>
      <Typography variant="subtitle2">
        Filter results by
      </Typography>

      <div>
        <Grid
          container
          alignItems="flex-start"
          spacing={gridSpacing}
          direction={isMobile && searchType === ProfileTypes.ACT ? 'column-reverse' : 'row'}
        >
          {searchType === ProfileTypes.VENUE && (
            <Grid
              item
              xs={12}
              md={5}
              className={classes.filterGridItem}
            >
              <Stack spacing={2}>
                <VenueTypes />

                <div>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    gutterBottom
                  >
                    Resources
                  </Typography>

                  <div>
                    <Checkbox name="hasPA">
                      Has a PA system
                    </Checkbox>
                  </div>
                </div>
              </Stack>
            </Grid>
          )}

          <Grid
            item
            xs={12}
            md={5}
            className={classes.filterGridItem}
          >
            <CheckboxGroup
              name="filter"
              label="Only include"
              row={false}
            >
              <Checkbox
                value={FilterOptions.FEATURED}
                margin="dense"
              >
                Featured Show Calls
              </Checkbox>

              {Boolean(searchType === ProfileTypes.VENUE) && (
                <Checkbox
                  value={FilterOptions.EXPERIENCED}
                  margin="dense"
                >
                  Experienced hosts
                </Checkbox>
              )}

              <Checkbox
                value={FilterOptions.PARTNER}
                margin="dense"
              >
                {searchType === ProfileTypes.ACT ? 'Partner artists' : 'Safer Space'}
              </Checkbox>
            </CheckboxGroup>
          </Grid>

          {searchType === ProfileTypes.ACT && (
            <Grid
              item
              xs={12}
              md={7}
              className={classes.filterGridItem}
            >
              <Stack spacing={2}>
                <Genres />

                <MultipleSelect
                  name="requiresPA"
                  label="Requires a PA system"
                >
                  <MenuItem
                    value={RequiresPAOptions.YES}
                    checkbox
                  >
                    Yes
                  </MenuItem>

                  <MenuItem
                    value={RequiresPAOptions.NO}
                    checkbox
                  >
                    No
                  </MenuItem>
                </MultipleSelect>
              </Stack>
            </Grid>
          )}
        </Grid>
      </div>
    </Stack>
  );
};
